import React from "react";
import { Modal } from "@pd/pd-ui-kit";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { REG_TYPE2 } from "~/pages/Accounting/AccountingPeriod/options";
import { Field } from "~/shared/ui/Field";

const excelFormId = "AccountingExcelReportForm";

export type ExcelFormData = {
  report: string;
};

interface AccountingExcelReportModalProps {
  loading: boolean;
  onReport: (data: ExcelFormData) => void;
}

const AccountingExcelReportModal = ({
  loading,
  onReport,
}: AccountingExcelReportModalProps) => {
  const { t } = useTranslation();
  const setDataReplace = useSetLocationData(true);
  const { openModal } = useGetLocationData();

  const { control, handleSubmit } = useForm<ExcelFormData>({
    defaultValues: { report: REG_TYPE2[0] },
  });

  const handleCloseModal = () => {
    setDataReplace("openModal", "", "currentId", "");
  };

  return (
    <Modal
      open={openModal === "Excel"}
      title={t("accounting.reportTitleExcel")}
      onCancel={handleCloseModal}
      closable
      centered
      destroyOnHidden
      okButton={{
        htmlType: "submit",
        form: excelFormId,
        children: t("ui.save"),
        loading,
      }}
    >
      <form id={excelFormId} onSubmit={handleSubmit(onReport)}>
        <Field
          type="select"
          name="report"
          control={control}
          label={t("accounting.ReportCheck")}
          options={REG_TYPE2.map((value) => ({
            value,
            label: t(`accounting.${value}`),
          }))}
        />
      </form>
    </Modal>
  );
};

export default AccountingExcelReportModal;
